import { Fragment } from "react";
import { CheckCircle } from "react-feather";
import { Modal, ModalBody } from "reactstrap";
import { Btn, H5 } from "../../../../AbstractElements";
import { AddTask, NewTask } from "../../../../Constants/Constants";
import { useAppDispatch, useAppSelector } from "../../../../ReduxToolkit/Hooks";
import { setAddModal } from "../../../../ReduxToolkit/Reducers/TaskSlice";
import { NewTaskModalForm } from "./NewTaskModalForm";

const NewTaskClass = () => {
  const { addModal } = useAppSelector((state) => state.task);
  const dispatch = useAppDispatch();
  const addToggle = () => dispatch(setAddModal());

  return (
    <Fragment>
      <Btn color="transparent" className="badge-light-primary btn-block btn-mail w-100" onClick={addToggle}><CheckCircle className="me-2" />{NewTask}</Btn>
      <Modal className="modal-bookmark" size="lg" isOpen={addModal} toggle={addToggle}>
        <div className="modal-header">
          <H5 className="modal-title">{AddTask}</H5>
          <Btn close color="transprant" onClick={addToggle} />
        </div>
        <ModalBody>
          <NewTaskModalForm />
        </ModalBody>
      </Modal>
    </Fragment>
  );
};
export default NewTaskClass;
